// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__HdVdr","ellipsis":"styles_ellipsis__Zbptt","text2AndMoreLines":"styles_text2AndMoreLines__SEfZx","tooltipTrigger":"styles_tooltipTrigger__m63Q5"};